'use server'

import { apiRequest, ApiResponse } from '../request'

export interface StoreWidget {
    id: number
    companyId: number
    name: string
    type: 'HTML' | 'JAVASCRIPT'
    content: string
    active: boolean
    createdAt: string
    updatedAt: string
}

// Widgets
export async function getWidgetsByCompany(
    companyId: number,
): Promise<ApiResponse<StoreWidget[]>> {
    return apiRequest<StoreWidget[]>(
        `store-widgets/company/${companyId}`,
        {},
    )
}

export async function getWidget(
    id: number,
): Promise<ApiResponse<StoreWidget>> {
    return apiRequest<StoreWidget>(`store-widgets/${id}`, {})
}

export async function createWidget(
    data: Partial<StoreWidget>,
): Promise<ApiResponse<StoreWidget>> {
    return apiRequest<StoreWidget>('store-widgets', { data }, 'post')
}

export async function updateWidget(
    id: number,
    data: Partial<StoreWidget>,
): Promise<ApiResponse<StoreWidget>> {
    return apiRequest<StoreWidget>(`store-widgets/${id}`, { data }, 'patch')
}

export async function deleteWidget(
    id: number,
): Promise<ApiResponse<void>> {
    return apiRequest<void>(`store-widgets/${id}`, {}, 'delete')
}
